import styled from 'styled-components'

export const PaymentSettingsContainerUI = styled.div`
  padding: 10px 20px;
`
